import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export default function PageTransition() {
  const location = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => setShow(false), 750);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="page-transition"
          className="fixed inset-0 z-[125] bg-[#75FB4E] pointer-events-none origin-bottom"
          initial={{ scaleY: 1 }}
          animate={{ scaleY: 0 }}
          exit={{ scaleY: 0 }}
          transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-mono-tech text-xs tracking-[0.4em] text-[#050505] uppercase">CR—L ©26</span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
